import Plot from '@models/Plot';
import React from 'react';
import MethodsSectionTitle from '@components/experiments/methods/MethodsSectionTitle';
import ProseList from '@/src/components/ProseList';
import { PlotDisplayOption } from '@/src/models/PlotDisplayOption';
import { AnalysisParameters, SampleSummaryCategoricalAnalysisParameters } from '@/src/models/AnalysisParameters';
import { SampleSummaryCategoricalAnalysis } from '@/src/models/analysis/SampleSummaryCategoricalAnalysis';
import { capitalizeWordsAndReplaceUnderscores } from '@/src/util/StringUtil';

type Props = { plot: Plot; analysisParameters: AnalysisParameters | null };
const SampleSummaryCategoricalAnalysisMethodsSection = ({ plot, analysisParameters: ap }: Props) => {
    const analysis = plot.analysis as unknown as SampleSummaryCategoricalAnalysis;
    const analysisParameters = ap as SampleSummaryCategoricalAnalysisParameters;
    if (!analysis) {
        return <div>No analysis was found.</div>;
    }

    const display = plot.display as PlotDisplayOption;

    const groupNames = analysis.groups.map((g) => g.display_name);
    const variableNames = analysis.variables.map((v) => {
        const matchVariable = analysisParameters.variables.find((s) => s.id === v);
        return matchVariable?.display_name ? capitalizeWordsAndReplaceUnderscores(matchVariable.display_name) : v;
    });

    return (
        <section>
            <section>
                <MethodsSectionTitle>Sample summary (categorical) analysis</MethodsSectionTitle>
                <p className="mb-6">
                    Samples were counted for each of the following groups: <ProseList items={groupNames} />.
                </p>
            </section>
            {display.display_type === 'pie_chart' ? (
                <section>
                    <MethodsSectionTitle>Pie Chart</MethodsSectionTitle>
                    <p className="mb-6">
                        Pie chart showing the counts of samples grouped by <ProseList items={variableNames} />, which
                        includes the following groups: <ProseList items={groupNames} />.
                    </p>
                </section>
            ) : null}
        </section>
    );
};

export default SampleSummaryCategoricalAnalysisMethodsSection;
